import { v4 as uuid } from 'uuid'
import PropTypes from 'prop-types'
import React from 'react'
import { Link as RouterLink, withRouter } from 'react-router-dom'
import { Link as ScrollLink } from 'react-scroll'

export const SCROLL_TYPE = 'scroll'
export const HREF_TYPE = 'href'
export const ROUTER_TYPE = 'router'
export const MODAL_TYPE = 'modal'
export const DRAWER_TYPE = 'drawer'
export const POPOVER_TYPE = 'popover'
export const MAILTO_TYPE = 'mailto'
export const DOWNLOAD_TYPE = 'download'

/** Mobile only types */
export const SMS_TYPE = 'sms'
export const MAPS_TYPE = 'maps'
export const CALL_TYPE = 'call'
export const FILE_TYPE = 'file'

// modal close btn enums
const LEFT = 'Left'
const CENTER = 'Center'
const RIGHT = 'Right'
const TOP = 'Top'
const BOTTOM = 'Bottom'
const CURSOR = ['auto', 'default', 'none', 'pointer', 'help']

const color = PropTypes.color
/**
 * Link Wrapper component allows sending users to different places.
 */
const LinkWrapper = withRouter(class LinkWrapper extends React.Component {
  static propTypes = {
    /**
     * Link string - either internal route or URL
     */
    link: PropTypes.string,

    /**
     * Type of link.
     */
    type: PropTypes.oneOf([undefined, SCROLL_TYPE, HREF_TYPE, ROUTER_TYPE, MODAL_TYPE, POPOVER_TYPE, DRAWER_TYPE, MAILTO_TYPE, SMS_TYPE, MAPS_TYPE, CALL_TYPE, FILE_TYPE, DOWNLOAD_TYPE]),

    /**
     * Target of link. _blank, _self, _parent, _top.
     */
    target: PropTypes.string,

    /**
     * Display settings
     */
    display: PropTypes.shape({
      width: PropTypes.string,
      height: PropTypes.string,
      transition: PropTypes.shape({
        enter: PropTypes.string,
        exit: PropTypes.string,
        duration: PropTypes.number
      }),
      attachment: PropTypes.string,
      targetAttachment: PropTypes.string,
      modal: PropTypes.shape({
        closeButton: PropTypes.shape({
          isVisible: PropTypes.bool,
          backgroundColor: color,
          color: color,
          text: PropTypes.string,
          width: PropTypes.string,
          height: PropTypes.string,
          horizontal: PropTypes.oneOf([
            LEFT,
            CENTER,
            RIGHT
          ]),
          vertical: PropTypes.oneOf([
            TOP,
            BOTTOM
          ])
        }),
        backgroundColor: color,
        showCloseX: PropTypes.bool,
        closeXColor: color,
        displayHeader: PropTypes.bool,
        headerText: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.object
        ])
      }),
      drawer: PropTypes.shape({
        placement: PropTypes.oneOf(['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end']),
        isModal: PropTypes.bool,
        closeOnOverlayClick: PropTypes.bool,
        showCloseButton: PropTypes.bool,
        width: PropTypes.string,
        height: PropTypes.string,
      })
    }),

    /**
     * On click handler
     */
    onClick: PropTypes.func,

    /**
     * On change handler
     */
    onChange: PropTypes.func,
    children: PropTypes.node,

    /**
     * Controls the styling properties of the component.
     */
    styling: PropTypes.shape({
      cursor: PropTypes.oneOf(CURSOR)
    })
  }
  chooseType (link) {
    switch (true) {
      case (!link): return ''
      case (link.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/g)): return SCROLL_TYPE // UUID-v4
      case (link.trim().startsWith('http')):
      case (link.trim().startsWith('www')): return HREF_TYPE // HTTP address
      case (!!link): return ROUTER_TYPE // Internal address
      default: return ''
    }
  }
  linkToPathname = (link) => {
    const { history } = this.props
    if (typeof link !== 'string' || !link.length || !history || !history.location) return
    return link
  }
  render () {
    const { link, type, onChange, onClick, history, children, target, modal, drawer, style = {}, styling = {}, ..._props } = this.props
    let { cmpId, _component, ctx, location, match, rootPath: _rp, staticContext: _sc,  ...props } = _props
    if (!cmpId) {
      cmpId = uuid()
    }
    if (this.props.isConfig) return <div>{children}</div>
    if (!link) return <div style={{ ...styling, ...style }} onClick={onClick}>{children}</div>
    switch (type || this.chooseType(link)) {
      case SCROLL_TYPE: return (
        <ScrollLink activeClass='active' to={link} spy smooth offset={50} duration={500} style={styling} {...props}>
          {children}
        </ScrollLink>
      )
      case HREF_TYPE:
        let hrefLink = typeof link === 'string' && (link.trim().startsWith('http') || link.trim().startsWith('/')) ? link : `http://${link}`
        return (
          <a href={hrefLink} style={styling} target={target} {...props}>
            {children}
          </a>
        )
      case DOWNLOAD_TYPE:
        return (
          <a href={link} style={styling} download={children}>
            {children}
          </a>
        )
      case ROUTER_TYPE: return (
        <RouterLink to={link} style={styling} {...props}>
          {children}
        </RouterLink>
      )
      case MODAL_TYPE:
        let modalConfig = {}
        if (this.props.display && this.props.display.modal) {
          modalConfig = this.props.display.modal
        } else if (modal) {
          modalConfig = modal
        }
        return (
          <RouterLink to={{
            pathname: this.linkToPathname(link),
            state: {
              modal: true,
              width: modalConfig.width,
              height: modalConfig.height,
              ...this.props.display
            },
            modalConfig
          }}
          style={styling}
          {...props}>
            {children}
          </RouterLink >
        )
      case DRAWER_TYPE:
        let drawerConfig
        if (this.props.display?.modal) {
          drawerConfig = this.props.display.modal
        } else if (drawer) {
          drawerConfig = drawer
        }
        <RouterLink to={{
          pathname: this.linkToPathname(link),
          state: {
            drawer: true,
            drawerConfig
          }
        }}
        style={styling}
        {...props}>
          {children}
        </RouterLink>
      case POPOVER_TYPE:
        return (
          <RouterLink
            
            to={{
              pathname: link,
              state: {
                popover: true,
                id: 'iar_' + cmpId,
                show: history && history.location && history.location.state && history.location.state.show != null ? !history.location.state.show : true,
                ...this.props.display || {}
              }
            }}
            style={styling}
            {...props}
            id={'iar_' + cmpId}
            className={'iar_' + cmpId}>
            {children}
          </RouterLink >
        )
      case MAILTO_TYPE: return (
        <a href={`mailto:${link}`} style={styling}>{children}</a>
      )
      case CALL_TYPE: return (
        <a href={`tel:${link}`} style={styling}>{children}</a>
      )
      default: return (
        <div style={{ ...styling, ...style }} {...props} onClick={onChange}>
          {children}
        </div>
      )
    }
  }
})
  
export default LinkWrapper
